import styled from 'styled-components';

export const InfoLoadingPlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  width: 100%;
`;
